import React, { useEffect, useState } from 'react';

// import '@ant-design/compatible/assets/index.css';


import { Form, Tabs, Card, Col, Row, Typography, Divider, Modal } from 'antd';

import DF from 'DisplayFramework';
import { toCurrency, toRate } from 'utils/utils';
import Text from 'components/Text';
import Checkbox from 'components/Checkbox';
import FormInput from 'components/FormInput';
import { PropDecisionResponse } from 'services/proposal';
import { useForm } from 'antd/lib/form/Form';
import Value from 'components/Value';

const { TabPane } = Tabs;
// eslint-disable-next-line no-unused-vars
const { Text: AntText } = Typography;

export type TabDecisionProps = {
  objectid?: number;
  data: PropDecisionResponse;
  onCancel: () => void;
  visible: boolean;
  onSuccess?: () => void;
};

const TabDecisionDetails = ({
  objectid,
  data,
  visible,
  onCancel,
  onSuccess,
}: TabDecisionProps) => {
  const [state, setState] = useState<any>({
    assets: [],
    CONTRACT: {},
    guaranty: [],
    insurance: [],
  });

  const [form] = useForm();

  useEffect(() => {
    if (data) {
      form?.setFieldsValue({
        reqfinamount: data?.reqfinamount,
        finamountapproved: data?.finamountapproved,
        rate: data?.rate,
        rateapproved: data?.rateapproved,
        duration: data?.duration,
        durationapproved: data?.durationapproved,

        firstpayment: data?.firstpayment,
        firstpaymentapproved: data?.firspaymentapproved,

        residualvalue: data?.residualvalue,
        residualvalueapproved: data?.residualvalueapproved,
        depositapproved: data?.depositapproved,
        deposit: data?.deposit,
        decdate: data?.decdate,
        declevel: data.declevel,
        dectype: data.dectype,
        deccode: data.deccode,
        assetreserve: data.assetreserve,
        assetnote: data.assetnote,
        coborrowernote: data.coborrowernote,
        coborrowerreserve: data.coborrowerreserve,
        created_at: data.created_at,
        created_by: data.created_by,
        ctrid: data.ctrid,
        deccodelabel: data.deccodelabel,
        deccomment: data.deccomment,
        decexternalref: data.decexternalref,
        decisionid: data.decisionid,
        declevellabel: data.declevellabel,
        decscore: data.decscore,
        depositreserve: data.depositreserve,
        durationreserve: data.durationreserve,
        finamountreserve: data.finamountreserve,
        firspaymentapproved: data.firspaymentapproved,
        firstpaymentreserve: data.firstpaymentreserve,
        guarantornote: data.guarantornote,
        guarantorreserve: data.guarantorreserve,
        insurancenote: data.insurancenote,
        insurancereserve: data.insurancereserve,
        ratereserve: data.ratereserve,
        residualvaluereserve: data.residualvaluereserve,
        updated_at: data.updated_at,
        updated_by: data.updated_by,
        warrantynote: data.warrantynote,
        warrantyreserve: data.warrantyreserve,
        username: data?.username,
      });

      setState((prev: any) => ({
        ...prev,
        CONTRACT: data,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return (
    (<DF.Provider pagcode="tabdecision">
      <Modal
        open={visible}
        onCancel={onCancel}
        onOk={onSuccess}
        width={1200}
        title="Decision Detail"
        footer={[]}
      >
        <Form form={form}>
          <Row>
            <Col span={24}>
              <Card size="small" type="inner" title="Decision" bordered>
                <Row gutter={[8, 8]}>
                  <Col xs={8}>
                    <FormInput name="deccodelabel">
                      <Value />
                    </FormInput>
                  </Col>
                  <Col xs={8}>
                    <FormInput name="decdate">
                      <Value />
                    </FormInput>
                  </Col>
                  <Col xs={8}>
                    <FormInput name="username">
                      <Value />
                    </FormInput>
                  </Col>
                </Row>

                <Tabs animated defaultActiveKey="1">
                  <TabPane tab="Financial" key={1} forceRender>
                    <Row gutter={[8, 8]}>
                      <Col span={4}>
                        <Text comcode="reqfinamount" />
                      </Col>
                      <Col span={6}>
                        <Form.Item style={{ margin: 0 }} name="reqfinamount">
                          <Value formatter={(value) => toCurrency(value,)} />
                        </Form.Item>
                      </Col>
                      <Col span={4}>
                        <Form.Item
                          style={{ margin: 0 }}
                          name="finamountreserve"
                          valuePropName="checked"
                          initialValue={false}
                        >
                          <Checkbox comcode="finamountreserve" disabled />
                        </Form.Item>
                      </Col>
                      <Col span={4}>
                        <Text comcode="finamountapproved" />
                      </Col>
                      <Col span={6}>
                        <Form.Item
                          style={{ margin: 0 }}
                          name="finamountapproved"
                        >
                          <Value formatter={(value) => toCurrency(value)} />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                      <Col span={4}>
                        <Text comcode="rate" />
                      </Col>
                      <Col span={6}>
                        <Form.Item style={{ margin: 0 }} name="rate">
                          <Value formatter={(value) => toRate(value)} />
                        </Form.Item>
                      </Col>
                      <Col span={4}>
                        <Form.Item
                          style={{ margin: 0 }}
                          name="ratereserve"
                          valuePropName="checked"
                          initialValue={false}
                        >
                          <Checkbox comcode="ratereserve" disabled />
                        </Form.Item>
                      </Col>
                      <Col span={4}>
                        <Text comcode="rateapproved" />
                      </Col>
                      <Col span={6}>
                        <Form.Item style={{ margin: 0 }} name="rateapproved">
                          <Value formatter={(value) => toRate(value)} />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                      <Col span={4}>
                        <Text comcode="duration" />
                      </Col>
                      <Col span={6}>
                        <Form.Item style={{ margin: 0 }} name="duration">
                          <Value />
                        </Form.Item>
                      </Col>
                      <Col span={4}>
                        <Form.Item
                          style={{ margin: 0 }}
                          name="durationreserve"
                          valuePropName="checked"
                          initialValue={false}
                        >
                          <Checkbox comcode="durationreserve" disabled />
                        </Form.Item>
                      </Col>
                      <Col span={4}>
                        <Text comcode="durationapproved" />
                      </Col>
                      <Col span={6}>
                        <Form.Item
                          style={{ margin: 0 }}
                          name="durationapproved"
                        >
                          <Value />
                        </Form.Item>
                      </Col>
                    </Row>

                    <Row gutter={[8, 8]}>
                      <Col span={4}>
                        <Text comcode="firstpayment" />
                      </Col>
                      <Col span={6}>
                        <Form.Item style={{ margin: 0 }} name="firstpayment">
                          <Value formatter={(value) => toCurrency(value)} />
                        </Form.Item>
                      </Col>
                      <Col span={4}>
                        <Form.Item
                          style={{ margin: 0 }}
                          name="firstpaymentreserve"
                          valuePropName="checked"
                          initialValue={false}
                        >
                          <Checkbox comcode="firstpaymentreserve" disabled />
                        </Form.Item>
                      </Col>
                      <Col span={4}>
                        <Text comcode="firstpaymentapproved" />
                      </Col>
                      <Col span={6}>
                        <Form.Item
                          style={{ margin: 0 }}
                          name="firstpaymentapproved"
                        >
                          <Value formatter={(value) => toCurrency(value)} />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                      <Col span={4}>
                        <Text comcode="residualvalue" />
                      </Col>
                      <Col span={6}>
                        <Form.Item style={{ margin: 0 }} name="residualvalue">
                          <Value formatter={(value) => toCurrency(value)} />
                        </Form.Item>
                      </Col>
                      <Col span={4}>
                        <Form.Item
                          style={{ margin: 0 }}
                          name="residualvaluereserve"
                          valuePropName="checked"
                          initialValue={false}
                        >
                          <Checkbox comcode="residualvaluereserve" disabled />
                        </Form.Item>
                      </Col>
                      <Col span={4}>
                        <Text comcode="residualvalueapproved" />
                      </Col>
                      <Col span={6}>
                        <Form.Item
                          style={{ margin: 0 }}
                          name="residualvalueapproved"
                        >
                          <Value formatter={(value) => toCurrency(value)} />
                        </Form.Item>
                      </Col>
                    </Row>

                    <Row gutter={[8, 8]}>
                      <Col span={4}>
                        <Text comcode="deposit" />
                      </Col>
                      <Col span={6}>
                        <Form.Item style={{ margin: 0 }} name="deposit">
                          <Value formatter={(value) => toCurrency(value)} />
                        </Form.Item>
                      </Col>
                      <Col span={4}>
                        <Form.Item
                          style={{ margin: 0 }}
                          name="depositreserve"
                          valuePropName="checked"
                          initialValue={false}
                        >
                          <Checkbox comcode="depositreserve" disabled />
                        </Form.Item>
                      </Col>
                      <Col span={4}>
                        <Text comcode="depositapproved" />
                      </Col>
                      <Col span={6}>
                        <Form.Item style={{ margin: 0 }} name="depositapproved">
                          <Value formatter={(value) => toCurrency(value)} />
                        </Form.Item>
                      </Col>
                    </Row>
                  </TabPane>
                  <TabPane tab="Asset" key={2} forceRender>
                    <Row>
                      <Col span={4}>List of Assets :</Col>
                      <Col span={20}>
                        {state.assets.map((asset: any, index: any) => (
                          <Row key={index}>
                            <Col span={20}>{asset.assetlabel}</Col>
                            <Col span={4}>{toCurrency(asset.assetnetamount,asset.currcode)}</Col>
                          </Row>
                        ))}
                      </Col>
                    </Row>
                    <Divider>Reserves</Divider>
                    <Row>
                      <Col span={4}>
                        <Form.Item
                          name="assetreserve"
                          valuePropName="checked"
                          initialValue={false}
                        >
                          <Checkbox comcode="assetreserve" disabled />
                        </Form.Item>
                      </Col>
                      <Col span={20}>
                        <Form.Item name="assetnote">
                          <Value />
                        </Form.Item>
                      </Col>
                    </Row>
                  </TabPane>
                  <TabPane tab="Guaranty" key={3} forceRender>
                    <Row>
                      <Col span={4}>List of Guaranties :</Col>
                      <Col span={20}>
                        {state.guaranty.map((guaranty: any, index: any) => (
                          <Row key={index}>
                            <Col span={10}>{guaranty.guartypelabel}</Col>
                            <Col span={10}>{guaranty.guarantorname}</Col>
                            <Col span={4}>{toCurrency(guaranty.guaramount)}</Col>
                          </Row>
                        ))}
                      </Col>
                    </Row>
                    <Divider>Reserves</Divider>
                    <Row>
                      <Col span={4}>
                        <Form.Item
                          name="warrantyreserve"
                          valuePropName="checked"
                          initialValue={false}
                        >
                          <Checkbox comcode="warrantyreserve" disabled />
                        </Form.Item>
                      </Col>
                      <Col span={20}>
                        <Form.Item name="warrantynote">
                          <Value />
                        </Form.Item>
                      </Col>
                    </Row>
                  </TabPane>

                  <TabPane tab="Insurances" key={4} forceRender>
                    <Row>
                      <Col span={4}>List of Insurances :</Col>
                      <Col span={20}>
                        {state.insurance.map((e: any, index: any) => (
                          <Row key={index}>
                            <Col span={20}>{e.instypelabel}</Col>
                            <Col span={4}>{toCurrency(e.insamount)}</Col>
                          </Row>
                        ))}
                      </Col>
                    </Row>
                    <Divider>Reserves</Divider>
                    <Row>
                      <Col span={4}>
                        <Form.Item
                          name="insurancereserve"
                          valuePropName="checked"
                          initialValue={false}
                        >
                          <Checkbox comcode="insurancereserve" disabled />
                        </Form.Item>
                      </Col>
                      <Col span={20}>
                        <Form.Item name="insurancenote">
                          <Value />
                        </Form.Item>
                      </Col>
                    </Row>
                  </TabPane>

                  <TabPane tab="Coborrower" key={5} forceRender>
                    <Row>
                      <Col span={4}>Coborrower</Col>
                      <Col span={20}>{state.CONTRACT.cobname}</Col>
                    </Row>
                    <Divider>Reserves</Divider>
                    <Row>
                      <Col span={4}>
                        <Form.Item
                          name="coborrowerreserve"
                          valuePropName="checked"
                          initialValue={false}
                        >
                          <Checkbox comcode="coborrowerreserve" disabled />
                        </Form.Item>
                      </Col>
                      <Col span={20}>
                        <Form.Item name="coborrowernote">
                          <Value />
                        </Form.Item>
                      </Col>
                    </Row>
                  </TabPane>

                  <TabPane tab="Guarantor" key={6} forceRender>
                    <Row>
                      <Col span={4}>Guarantor</Col>
                      <Col span={20}>{state.CONTRACT.guarantorname}</Col>
                    </Row>
                    <Divider>Reserves</Divider>
                    <Row>
                      <Col span={4}>
                        <Form.Item
                          name="guarantorreserve"
                          valuePropName="checked"
                          initialValue={false}
                        >
                          <Checkbox comcode="guarantorreserve" disabled />
                        </Form.Item>
                      </Col>
                      <Col span={20}>
                        <Form.Item name="guarantornote">
                          <Value />
                        </Form.Item>
                      </Col>
                    </Row>
                  </TabPane>

                  <TabPane tab="Notes & comments" key={7} forceRender>
                    <FormInput name="deccomment">
                      <Value />
                    </FormInput>
                  </TabPane>
                </Tabs>
              </Card>
            </Col>
          </Row>
        </Form>
      </Modal>
    </DF.Provider>)
  );
};
export default TabDecisionDetails;
